import { NoticeTypes } from '@genial/components';
import { Utils } from '@genial/utils';

const PRODUCTS_WITHOUT_HISTORY = ['Cripto'];

export const getNoticeText = (date: Date): string => {
  return `Informações do dia ${Utils.Mask.DateFormat(date, 'dd/MM/yyyy')}.`;
};

export const getAlertText = (): NoticeTypes.TextObject[] => {
  return [
    { text: 'A visualização de posição histórica para este produto está ', variant: 'regular' },
    { text: 'temporariamente indisponível. ', variant: 'semibold' },
  ];
};

export const shouldBlockHistoricalSearch = (product?: { marketNameNormalized?: string }) => {
  if (!product?.marketNameNormalized) {
    return false;
  }
  return PRODUCTS_WITHOUT_HISTORY.includes(product.marketNameNormalized || '');
};
